import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20abstract%20photographic%20texture%20of%20layered%20charcoal%20paper%20sheets%20with%20one%20deep%20crimson%20seam%20and%20faint%20amber%20edge%20glow%2C%20moody%20cinematic%20documentary%20atmosphere%2C%20subtle%20grain%2C%20no%20people%2C%20no%20text&width=1600&height=700&seq=cta-dossier-band-2026&orientation=landscape"
        alt="暗色纸张纹理背景，象征封存的调查档案"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/85 to-background-950/70"></div>

      <div className="relative z-10 max-w-[1240px] mx-auto px-4 md:px-10 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7">
          <p className="text-xs font-medium tracking-[0.24em] uppercase text-accent-400 mb-4">
            线索征集 · 长期有效
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
            你经历过的那个「说不清哪里不对」，
            <br className="hidden md:block" />
            可能就是下一条线索
          </h2>
          <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl">
            报价单、合同、聊天记录、一段对话的原话，都可以。我们只做匿名整理，不公开来源，也不会把线索转给任何第三方。
          </p>
        </div>
        <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-stretch">
          <Link
            to="/about#submit"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            提交爆料线索
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-folder-open-line" aria-hidden="true"></i>
            先看看已有档案
          </Link>
        </div>
      </div>
    </section>
  );
}